import React from 'react';
import { motion } from 'framer-motion';
import { Check, Globe, Lock, Shield, Sparkles, Zap } from 'lucide-react';
import { Button } from './Button';
import { checkoutUrl, comboIncludes, ctaLabel, price, trackCheckout } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-cream relative border-y border-silver-light" data-id="element-179" data-mp="1j8p1xdh65dik">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-180" data-mp="1nasp2zd7a6jo">
        <div className="text-center mb-10" data-id="element-181" data-mp="1naaknfgdwm0o">
          <h2 className="text-3xl md:text-5xl font-display font-extrabold mb-3 text-ink" data-id="element-182" data-mp="1s9dgc9ah5fvz">
            Your complete offer today
          </h2>
          <p className="text-graphite text-sm md:text-base" data-id="element-183" data-mp="1x99kc8j697bj">
            Complete Teaching Library + 5 strategic bonuses — ready for your next session.
          </p>
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-cream-light border-2 border-brand rounded-3xl p-1 relative shadow-[0_20px_50px_-34px_rgba(51,50,45,0.4)]" data-id="element-184" data-mp="2vqrvd400ex3">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-brand text-white font-bold px-5 py-1.5 rounded-full uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap" data-id="element-185" data-mp="1ho51ef2zsgg2">
            <Sparkles size={14} aria-hidden="true" data-id="element-186" data-mp="17pxms2w6eah8" /> Complete Package
          </div>
          <div className="bg-paper rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-187" data-mp="25dg4w4bq8oxw">
            <h3 className="text-2xl md:text-3xl font-display font-extrabold text-brand mb-3" data-id="element-188" data-mp="20gz7ejin0y85">
              Mindfulness &amp; Meditation Teacher Ready
            </h3>
            <p className="text-base text-graphite mb-6" data-id="element-189" data-mp="1rgj5vflgg15x">
              The complete professional library to teach mindfulness and meditation with confidence.
            </p>
            <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-cream-light border border-silver-light rounded-xl p-4" data-id="element-190" data-mp="g0m58u497ssv">
              {comboIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-graphite" data-id="element-191" data-mp="hfosbjjapm46">
                  <Check size={16} className="text-brand shrink-0 mt-0.5" aria-hidden="true" data-id="element-192" data-mp="mg32p88dd85d" />
                  <span data-id="element-193" data-mp="7jc1ctf4xmd4">{item}</span>
                </li>)}
            </ul>
            <div className="mb-6" data-id="element-194" data-mp="ch3s3k41n2fq">
              <span className="text-lg text-graphite-light line-through block mb-1" data-id="element-195" data-mp="ckhswnx273l2">
                {price.regular}
              </span>
              <div className="flex flex-wrap items-baseline justify-center gap-2" data-id="element-196" data-mp="3i8kc3lcpkab">
                <span className="text-2xl md:text-3xl text-ink" data-id="element-197" data-mp="3kz08rbt8rnf8">TODAY:</span>
                <span className="text-4xl md:text-5xl font-bold text-accent" data-id="element-198" data-mp="3pxkyghavaopf">{price.today}</span>
              </div>
              <p className="text-sm text-olive font-semibold mt-2" data-id="element-199" data-mp="3by254umpthx6">
                That&apos;s 83% off the regular price.
              </p>
            </div>
            <Button href={checkoutUrl} target="_blank" onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-200" data-mp="3fylx7jsflvcg">
              {ctaLabel}
            </Button>
            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-graphite-light mb-4" data-id="element-201" data-mp="36cui816nwoaq">
              <span className="flex items-center gap-1.5" data-id="element-202" data-mp="31bx2rwd1e8cx">
                <Lock size={12} className="text-brand" aria-hidden="true" data-id="element-203" data-mp="3g9pfkgr78inf" /> Secure payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-204" data-mp="3bbe82codmk8d">
                <Zap size={12} className="text-brand" aria-hidden="true" data-id="element-205" data-mp="3b8ryk7hxduni" /> Instant access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-206" data-mp="3p43sico9bh3d">
                <Shield size={12} className="text-brand" aria-hidden="true" data-id="element-207" data-mp="3l1z4pukhpeon" /> 7-day guarantee
              </span>
            </div>
            <div className="bg-cream border border-silver-light rounded-xl p-3 max-w-md mx-auto flex items-start gap-2.5 text-left" data-id="element-208" data-mp="2sq4rznk7buq">
              <Globe className="text-brand shrink-0 mt-0.5" size={14} aria-hidden="true" data-id="element-209" data-mp="hym78piv77j1" />
              <p className="text-[11px] text-graphite-light leading-snug" data-id="element-210" data-mp="lzfudgohgiav">
                Pay in your local currency. The amount automatically adjusts based on your country.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}